<div class="pagination">
    <button (click)="onPageChange(1)" [class.active]="currentPage === 1" *ngIf="firstPage > 1">1</button>
    <ng-container *ngIf="totalPages > 1 && !showEllipsis">
        <button (click)="onPageChange(1)" [class.active]="currentPage === 1">1</button>
    </ng-container>
    <ng-container *ngIf="showEllipsis">
        <span *ngIf="firstPage > 2">...</span>
        <button *ngFor="let page of pages" [class.active]="currentPage === page" (click)="onPageChange(page)">
            {{ page }}
        </button>
    </ng-container>
    <span *ngIf="showEllipsis && firstPage + pages.length <= totalPages - 1">...</span>
    <ng-container *ngIf="totalPages > 1">
        <button (click)="onPageChange(totalPages)" [class.active]="currentPage === totalPages">Last</button>
    </ng-container>
</div>
